import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Promotions from "@/components/Promote/Promotions";
import axios from "axios";
import { InferGetStaticPropsType } from "next";


const PromotionsPage = ({
  promotions,
}: InferGetStaticPropsType<typeof getStaticProps>) => {

  return (
    <>
      <Header />
      <Promotions {...promotions} />
      <Footer />
    </>
  )
}

export default PromotionsPage

export const getStaticProps = async () => {
  const response = await axios.get(
    process.env.NEXT_PUBLIC_API_URL! + process.env.NEXT_PUBLIC_API_PROMOTE! + "/promotion"
  );

  return {
    props: { promotions: response.data },
    revalidate: 1800,
  }
}
